/**
 * Retrieves the primary phone number from a department.
 * @param {ADDDepartment | ADDResponse} department - The department to retrieve the phone number from
 * @returns {string | undefined} - The primary phone number or undefined if not found
 */
export const getPhone = (department) => {
	/**
	 * @type {ADDPhoneNumbers[]}
	 */
	const phones =
		department.contactInformation?.phoneNumbers ??
		department.primaryContactInformation?.phoneNumbers ??
		[];
	const phone = phones.find((p) => p.type === 'WORK') ?? phones[0];
	return phone?.number;
};
